import React from 'react';
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGithub,
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Branding */}
        <div className="footer-column">
          <h3 className="footer-logo">Novacrest system inc.</h3>
          <p className="footer-description">
            Innovating the future with AI, Cloud, and Scalable Software Solutions.
          </p>
        </div>

        {/* Navigation */}
        <div className="footer-column">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/projects">Portfolio</a></li>
            <li><a href="/contact-us">Contact</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-column">
          <h4 className="footer-heading">Contact Us</h4>
          <p>Email: <a href="mailto:contact@novacrest.ca">contact@novacrest.ca</a></p>
          <p>Phone: <a href="+1 (800) 123-4567">+1 (800) 123-4567</a></p>
          <p>Address: 5266 Kimball Crescent SW, Edmonton, Alberta, T6W 4Z3</p>
        </div>

        {/* Social */}
        <div className="footer-column">
          <h4 className="footer-heading">Follow Us</h4>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer">
              <FaTwitter />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              <FaLinkedinIn />
            </a>
           
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} NovaCrest System Inc.. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
